<template>
	<div class="container">
		<!--页面开始-->
		<div class="step_box">
			<div class="step_el">
				<van-image
				  width="100%"
				  height="auto"
				  lazy-load
				  show-loading
				  :src="require('@/assets/img/chinese/step_10.webp')"
				>
					<template v-slot:loading>
						<div class="wrap color-A">
							<div class="k-line k-lineA-1"></div>
							<div class="k-line k-lineA-2"></div>
							<div class="k-line k-lineA-3"></div>
							<div class="k-line k-lineA-4"></div>
						</div>
					</template>
				</van-image>
				<div class="tit">A</div>
				<div class="step_txt">
					<ul>
						<li>将拭子插入样本处理管底部。</li>
						<li>将拭子头紧贴管底和管壁并旋转拭子至少 10 次。</li>
					</ul>
				</div>
			</div>
			
			<div class="step_el">
				<van-image
				  width="100%"
				  height="auto"
				  lazy-load
				  show-loading
				  :src="require('@/assets/img/chinese/step_11.webp')"
				>
					<template v-slot:loading>
						<div class="wrap color-A">
							<div class="k-line k-lineA-1"></div>
							<div class="k-line k-lineA-2"></div>
							<div class="k-line k-lineA-3"></div>
							<div class="k-line k-lineA-4"></div>
						</div>
					</template>
				</van-image>
				<div class="tit">B</div>
				<div class="step_txt">
					<ul>
						<li>取出拭子的同时挤压管壁，尽可能多地挤出拭子中的液体。</li>
						<li>用滴头盖紧样本处理管。</li>
					</ul>
				</div>
			</div>
		</div>
		<div class="btn_box">
			<van-button
				type="primary"
				block
				round
				color="linear-gradient(to right, #a74af2, #5949f2)"
				@click="goStepFive"
			>
				下一步
			</van-button>
		</div>
		<!--页面开始-->
	</div>
</template>

<script>
export default {
	components:{
		//
	},
	data() {
		return {
			noSleep: null,  //屏幕常亮对象
		}
	},
	beforeCreate() {
		document.querySelector('body').setAttribute('style', 'background-color:#fbfbfb;');
	},
	created(){
		//
	},
	mounted() {
		//
	},
	watch: {
		//
	},
	methods: {
		goStepFive() {
			this.$router.push({path:'/chinese/stepFive'});
		},
	},
	beforeDestroy() {
		document.querySelector('body').removeAttribute('style');
	},
	destroyed() {
		//
	}
}
</script>
</script>

<style scoped>
.container{
	/* position: absolute;
	height: 100vh;
	background-color: #fbfbfb; */
}
.step_box{
	position: relative;
	padding: 0.32rem 0.32rem 0 0.32rem;
}
.step_box .step_el{
	background-color: #ffffff;
	margin-bottom: 0.32rem;
	border-radius: 0.32rem;
	box-shadow: 0 0 0.4rem rgb(0, 0, 0, 0.1);
	overflow: hidden;
	position: relative;
	border: 1px solid #E9E9E9;
}
.step_box .step_el:last-child{
	margin-bottom: 0;
}
/* .step_box, .btn_box{background-color: #fbfbfb;} */
.step_box{padding-bottom: 0.64rem !important;}
/*步骤下说明文字*/
.step_txt{
	padding: 0.533rem 0.64rem 0.427rem 0.64rem;
	color: #333333;
}

.step_box img{
	width: 100%;
	height: auto;
}
.step_box .step_el{
	position: relative;
}
.step_box .step_el:last-child{
	padding-bottom: 0;
}
.step_box .step_el .tit{
	position: absolute;
	top: 0.32rem;
	left: 0.32rem;
	font-size: 0.533rem;
	color: #333333;
	font-weight: bold;
}
.btn_box{
	padding:0rem 0.9rem 1.107rem 0.9rem;
}
.step_box img, .btn_box img{width: 100%;}

.step_txt .txt_note{
	padding-top: 0.64rem;
	color: #720000;
	font-weight: bold;
}
.step_txt .pad_bot{
	padding-bottom: 0.1rem;
}
ul li{
	padding: 0 0 0.1rem 0;
}
ul li:last-child{
	padding-bottom: 0;
}


>>> .van-button{height: 1.2rem;}
>>> .van-button__text{color: #ffffff;font-size: 0.48rem;font-weight: bold;}

@media screen and (min-device-width : 768px){
	.btn_box{
		/* position: relative;
		width: 100%;
		padding: 3rem 0.9rem 0 0.9rem; */
	}
} 
</style>
